import type { FormValues, FormValuesEvent } from "@/widgets/classic-form/form";
import type { SpecialFieldGroup } from "@/entities/form-metadata";

const populateInstances = (
    formValuesEventsData: FormValues["events"],
    eventKey: string,
    dataModelEvent?: FormValuesEvent,
) => {
    if (formValuesEventsData[eventKey]?.instances.length) return;
    if (dataModelEvent && dataModelEvent.instances.length) {
        formValuesEventsData[eventKey]?.instances.push(...dataModelEvent.instances);
    }
};

export const populateSpecialFields = ({
    fieldGroup,
    dataModel,
    formValuesEventsData,
    isEditForm,
}: {
    fieldGroup: SpecialFieldGroup;
    dataModel: FormValues;
    formValuesEventsData: FormValues["events"];
    isEditForm: boolean;
}) => {
    const { events: eventsFromDataModel } = dataModel;
    if (isEditForm) return;
    fieldGroup.specialFields?.forEach((specialFieldItem) => {
        // @ts-ignore FIXME
        const specialFieldAssertion = specialFieldItem.fields[0].assertion;
        const dataModeKey = specialFieldAssertion === "Place" ? "Self" : "SelfBirth";

        const dataModelEvent = eventsFromDataModel[dataModeKey];

        populateInstances(formValuesEventsData, dataModeKey, dataModelEvent);
    });
};
